import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ProductCard from './ProductCard';
import { cartActions } from '../../redux/slices/cartSlice';

const ProductsList = ({ data, wrapWithCol = true }) => {
    const dispatch = useDispatch();
    const lastActionStatus = useSelector(state => state.cart.lastActionStatus);
    const [activeCard, setActiveCard] = useState(null);

    useEffect(() => {
      if (!lastActionStatus) return;

      const { success, message, product } = lastActionStatus;

      if (success) {
        toast(
          <CustomToast product={product} message={message} />, 
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            closeButton: false,
            className: "add-to-cart-toast",
          }
        );
      } else {
        toast.error(message);
      }

      dispatch(cartActions.clearActionStatus());
    }, [lastActionStatus]);

    const CustomToast = ({ product, message }) => (
      <div className="cart_custom-toast">
          <span className="cart_toast-icon"><i class="ri-check-fill"></i></span>
          <div className="cart_toast-message">
              <p className='cart_toast-text'>{message}</p>
          </div>
          <img 
              src={product.imgUrl}
              loading='lazy'
              alt={product.productName} 
              className="cart_toast-image"
          />
          <span 
              className="cart_toast-close" 
              onClick={() => toast.dismiss()}
              role="button" 
              tabIndex={0} 
              aria-label="Close toast"
          >
            <i class="ri-close-circle-fill"></i>
          </span>
      </div>
    );

    return (
      <>
        {data?.map((item, index) => (
          <ProductCard 
              key={index} 
              item={item} 
              wrapWithCol={wrapWithCol}
              activeCard={activeCard}
              setActiveCard={setActiveCard}
          /> 
        ))}
      </>
    );
};

export default ProductsList;
